
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPanelRightClose as ObiPanelRightCloseElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-panel-right-close.js';
 
 
 

 
 export const ObiPanelRightClose = createComponent({
   react: React,
   tagName: 'obi-panel-right-close',
   elementClass: ObiPanelRightCloseElement,
   events: {
     
   }
  });
 
 